import { CalendarOutlined } from '@ant-design/icons'
import { PageTitle } from '@supplement-bacon/react-toolkit/components'
import { useSBRM } from '@supplement-bacon/sbrm-react'
import { Card, Space, Tag } from 'antd'
import dayjs from 'dayjs'
import { useEffect, useState } from 'react'
import { FeaturedVenue } from '../../models/FeaturedVenue'
import { fetchFeaturedVenuesLive } from '../../services/FeaturedVenuesService'
import { Venue } from '../venue/Venue'
import { FeaturedVenuesTag } from './Tag'

const FeaturedVenuesLive = () => {
  /**
   * As this is not going through the redux store, `venues` attributes is an array of venues instead of an array of venue IDs
   */
  const [featured, setFeatured] = useState<FeaturedVenue | undefined>(undefined)
  const { isOpen } = useSBRM()

  useEffect(() => {
    fetchFeaturedVenuesLive().then((data) => {
      setFeatured(data.data)
    })
  }, [])

  useEffect(() => {
    if (isOpen) return
    fetchFeaturedVenuesLive().then((data) => {
      setFeatured(data.data)
    })
  }, [isOpen])

  if (!featured) {
    return <></>
  }

  return (
    <Space orientation="vertical" className="w-full">
      <PageTitle title="Live" level={4} />
      <Card>
        <Space className="w-full space-between">
          <Space>
            <Venue.AvatarGroup
              models={featured.venues}
              size={60}
              maxCount={10}
            />
            <FeaturedVenuesTag id={featured.id} />
          </Space>
          <Tag icon={<CalendarOutlined />}>
            {`${dayjs(featured.startDate).format('DD MMM')} - ${dayjs(featured.endDate).format('DD MMM')}`}
          </Tag>
        </Space>
      </Card>
    </Space>
  )
}

type FeaturedVenuesLiveType = { Live: typeof FeaturedVenuesLive }

export { FeaturedVenuesLive, type FeaturedVenuesLiveType }
